// import moment from 'moment'
import ApiLocation from '../location'

export default {
  createRsvp (VueApp, params, callback) {
    let self = this
    if (params.lyft) {
      ApiLocation.getTimezone(self, {
        lat: params.legs[0].pickup.lat,
        lng: params.legs[0].pickup.lng
      }, function (res) {
        params.legs[0].pickupTimezone = res
        self._createRsvp(VueApp, params, callback)
      })
      return
    }
    self._createRsvp(VueApp, params, callback)
  },
  _createRsvp (VueApp, params, callback) {
    VueApp.$sdk.post('/admin/rsvp/new', params, res => {
      callback(res)
    })
  },
  getSequestId (VueApp, params, callback) {
    VueApp.$sdk.post('/admin/rsvp/asap', params, res => {
      callback(res)
    })
  },
  getDriver (VueApp, params, callback) {
    VueApp.$sdk.post('/reservations/sequence/', params, res => {
      callback(res)
    })
  },
  getCards (VueApp, id, callback) {
    VueApp.$sdk.get('/consumer/' + id + '/cards', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
      if (res.list.length) {
        let cards = []
        res.list.forEach(function (data) {
          cards.push({
            id: data.ID,
            name: data.title + ' ****-' + data.cardNumber.substr(-4)
          })
        })
        VueApp.$store.commit('rsvpDetails/setUserCardList', cards)
      } else {
        VueApp.$store.commit('rsvpDetails/setUserCardList', [])
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/reservation-details/add.js